import React from 'react'
import { Link, useHistory } from '@fs/zion-router'
import { scrollWithOffset } from './useJumpLinks'

function getHashLinkStyle({ sectionId, activeSectionId }) {
  return activeSectionId === sectionId
    ? { fontWeight: 'bold', color: 'var(--gray100)', textDecoration: 'none', textWrap: 'nowrap', fontSize: 16 }
    : { color: 'var(--gray100)', textDecoration: 'none', textWrap: 'nowrap', fontSize: 16 }
}

export default function SectionLink({ id, linkName, text, activeSectionId, children }) {
  const history = useHistory()
  return (
    <Link
      to={`#${id}`}
      linkName={linkName}
      wayfinding
      external
      isGray
      noPrependLocaleCode
      style={getHashLinkStyle({ activeSectionId, sectionId: id })}
      onClick={(evt) => {
        evt.preventDefault()
        const el = document.getElementById(id)
        if (el) {
          scrollWithOffset(el)
          history.push({ hash: `#${id}` })
        }
      }}
    >
      {text || children}
    </Link>
  )
}
